// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__O-mye","boxTitle":"Qualiphy_boxTitle__mryr7","box":"Qualiphy_box__26wQJ","toggleWrap":"Qualiphy_toggleWrap__3nk2x"};